export default __webpack_public_path__ + "static/media/kk-correct.cd935ee4.png";